import { getTransactionLogList } from "@/helpers/service/api/report";
import { json2csv_fn, taxRatesMap, toThousands } from "@/utils/common";
import locale from "@/helpers/locale";
import moment from "moment";
import { getExportName_fn } from '@/utils/common'
export function exportCSV_fn(requestParma, operations, type, startDate, endDate, weekLocaleArray) {
  getTransactionLogList(requestParma).then(res => {
    if (res.data.data.length > 0) {
      let csvData = [];
      const week = [
        locale("global.sun"),
        locale("global.mon"),
        locale("global.tue"),
        locale("global.wed"),
        locale("global.thu"),
        locale("global.fri"),
        locale("global.sat")
      ];
      const fieldsObj = {
        ticket: [
          {
            label: locale("trans.koisk.transid"),
            value: "searchId",
          },
          {
            label: locale("trans.log.createTime"),
            value: "createTime",
          },
          {
            label: locale("global.type"),
            value: "operationType",
          },
          {
            label: locale("trans.log.transactionFinishTime"),
            value: "transactionFinishTime",
          },
          {
            label: locale("global.titleOfWork"),
            value: "filmName",
          },
          // {
          //   label: locale("trans.report.scheduleStartTime"),
          //   value: "scheduleStartTime",
          // },
          {
            label: locale("operation.NAT.screenDate"),
            value: "scheduleDate",
          },
          {
            label: locale("operation.NAT.showTime"),
            value: "scheduleTime",
          },
          {
            label: locale("trans.log.ticketName"),
            value: "ticketTypeNameOrProductName",
          },
          {
            label: locale("global.amount"),
            value: "totalAmount",
          },
          {
            label: locale("trans.log.changePeople"),
            value: "userName",
          },
          {
            label: locale("trans.log.mark"),
            value: "mark",
          },
        ],
        goods: [
          {
            label: locale("global.id"),
            value: "searchId",
          },
          {
            label: locale("trans.log.createTime"),
            value: "createTime",
          },
          {
            label: locale("global.type"),
            value: "operationType",
          },
          {
            label: locale("trans.log.transactionFinishTime"),
            value: "transactionFinishTime",
          },
          {
            label: locale("trans.log.productName"),
            value: "ticketTypeNameOrProductName",
          },
          {
            label: locale("global.unitPrice"),
            value: "unitPrice",
          },
          {
            label: locale("global.quantity"),
            value: "qty",
          },
          {
            label: locale("global.amount"),
            value: "totalAmount",
          },
          {
            label: locale("global.taxRate"),
            value: "taxRate",
          },
          {
            label: locale("trans.log.changePeople"),
            value: "userName",
          },
          {
            label: locale("trans.log.mark"),
            value: "mark",
          },
        ],
        otherRevenue: [
          {
            label: locale("global.id"),
            value: "searchId",
          },
          {
            label: locale("trans.log.createTime"),
            value: "createTime",
          },
          {
            label: locale("global.type"),
            value: "operationType",
          },
          {
            label: locale("trans.log.transactionFinishTime"),
            value: "transactionFinishTime",
          },
          {
            label: locale("trans.log.productName"),
            value: "ticketTypeNameOrProductName",
          },
          {
            label: locale("global.unitPrice"),
            value: "unitPrice",
          },
          {
            label: locale("global.quantity"),
            value: "qty",
          },
          {
            label: locale("global.amount"),
            value: "totalAmount",
          },
          {
            label: locale("global.unit"),
            value: "unit",
          },
          {
            label: locale("global.taxRate"),
            value: "taxRate",
          },
          {
            label: locale("trans.log.changePeople"),
            value: "userName",
          },
          {
            label: locale("trans.log.mark"),
            value: "mark",
          },
        ],
      };
      const fileNames = {
        ticket: locale("sideMenu.reports.transactionLogTicket"),
        goods: locale("sideMenu.reports.transactionLogShop"),
        otherRevenue: locale("sideMenu.reports.transactionLogOtherRevenue")
      };
      switch(type) {
      case "ticket":
        res.data.data.forEach(item => {
          csvData.push({
            searchId: item.searchId + "\t",
            createTime: moment(item.createTime).format(`YYYY${locale("global.year")}MM${locale("global.month")}DD${locale("global.day")}(${week[moment(item.createTime).day()]})HH:mm`),
            operationType: operations.find(operation => operation.value === item.operationType) ? operations.find(operation => operation.value === item.operationType).label : "",
            transactionFinishTime: moment(item.transactionFinishTime).format(`YYYY${locale("global.year")}MM${locale("global.month")}DD${locale("global.day")}(${week[moment(item.transactionFinishTime).day()]})HH:mm`),
            filmName: item.filmName,
            // scheduleStartTime: moment(item.scheduleStartTime).format(`YYYY${locale("global.year")}MM${locale("global.month")}DD${locale("global.day")}(${week[moment(item.scheduleStartTime).day()]})HH:mm`),
            scheduleDate: moment(item.scheduleStartTime).format("YYYY-MM-DD"),
            scheduleTime: moment(item.scheduleStartTime).format("HH:mm"),
            ticketTypeNameOrProductName: item.ticketTypeNameOrProductName,
            totalAmount: item.totalAmount,
            userName: item.userName,
            mark: item.mark
          });
        });
        break;
      case "goods":
        res.data.data.forEach(item => {
          csvData.push({
            searchId: item.searchId + "\t",
            createTime: moment(item.createTime).format(`YYYY${locale("global.year")}MM${locale("global.month")}DD${locale("global.day")}(${week[moment(item.createTime).day()]})HH:mm`),
            operationType: operations.find(operation => operation.value === item.operationType) ? operations.find(operation => operation.value === item.operationType).label : "",
            transactionFinishTime: moment(item.transactionFinishTime).format(`YYYY${locale("global.year")}MM${locale("global.month")}DD${locale("global.day")}(${week[moment(item.transactionFinishTime).day()]})HH:mm`),
            ticketTypeNameOrProductName: item.ticketTypeNameOrProductName,
            unitPrice: item.unitPrice,
            qty: toThousands(item.qty),
            totalAmount: item.totalAmount,
            taxRate: taxRatesMap[item.taxRate.toString()],
            userName: item.userName,
            mark: item.mark
          });
        });
        break;
      case "otherRevenue":
        res.data.data.forEach(item => {
          csvData.push({
            searchId: item.searchId + "\t",
            createTime: moment(item.createTime).format(`YYYY${locale("global.year")}MM${locale("global.month")}DD${locale("global.day")}(${week[moment(item.createTime).day()]})HH:mm`),
            operationType: operations.find(operation => operation.value === item.operationType) ? operations.find(operation => operation.value === item.operationType).label : "",
            transactionFinishTime: moment(item.transactionFinishTime).format(`YYYY${locale("global.year")}MM${locale("global.month")}DD${locale("global.day")}(${week[moment(item.transactionFinishTime).day()]})HH:mm`),
            ticketTypeNameOrProductName: item.ticketTypeNameOrProductName,
            unitPrice: item.unitPrice,
            qty: toThousands(item.qty),
            totalAmount: item.totalAmount,
            unit: item.unit,
            taxRate: taxRatesMap[item.taxRate.toString()],
            userName: item.userName,
            mark: item.mark
          });
        });
        break;
      default:
        break;
      }
      json2csv_fn(csvData, fieldsObj[type],
      // fileNames[type]
      getExportName_fn(
        fileNames[type],
        '',
        '',
        '',
        `${moment(startDate).format('YYYY-MM-DD')} （${weekLocaleArray[moment(startDate).day()]}）~ ${moment(endDate).format('YYYY-MM-DD')} （${weekLocaleArray[moment(endDate).day()]}）`,
        '',
        moment().format('YYYYMMDDHHmm')
      )
      );
    }
  });
}